<template>
  <div class="content">
    <div class="pt20">
      <div class="back" @click="back(false)">
        <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
        <span>{{ $t('courseReviewDetail.back') }}</span>
      </div>
      <h4>{{ $t('courseReviewDetail.courseSettings.title') }}</h4>
      <a-form :form="form" layout="vertical" autocomplete="off">
        <div class="title">{{ $t('courseReviewDetail.basicInfo') }}</div>
        <div class="list">
          <a-form-item class="full" :label="$t('courseReviewDetail.courseSettings.archiveStatus.label')" :colon="false">
            <a-select
              v-decorator="['archiveStatus', { rules: [{ required: true, message: $t('courseReviewDetail.courseSettings.archiveStatus.required') }] }]"
              :placeholder="$t('courseReviewDetail.courseSettings.archiveStatus.placeholder')"
            >
              <a-select-option value="1">{{ $t('courseReviewDetail.courseSettings.archiveStatus.unarchive') }}</a-select-option>
              <a-select-option value="2">{{ $t('courseReviewDetail.courseSettings.archiveStatus.archive') }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('courseReviewDetail.courseSettings.semester.label')" :colon="false">
            <a-select v-decorator="['semesterId', { rules: [] }]" :placeholder="$t('courseReviewDetail.courseSettings.semester.placeholder')">
              <a-select-option :value="item.id" v-for="item in semesterList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="list">
          <a-form-item :label="$t('courseReviewDetail.courseSettings.userPermission.label')" :colon="false">
            <a-select
              mode="multiple"
              v-decorator="['viewPermission', { rules: [{ required: true, message: $t('courseReviewDetail.courseSettings.userPermission.required') }] }]"
              :placeholder="$t('courseReviewDetail.courseSettings.userPermission.placeholder')"
            >
              <a-select-option value="internal_teacher">{{ $t('courseReviewDetail.courseSettings.userPermission.internalTeacher') }}</a-select-option>
              <a-select-option value="internal_student">{{ $t('courseReviewDetail.courseSettings.userPermission.internalStudent') }}</a-select-option>
              <a-select-option value="external_teacher">{{ $t('courseReviewDetail.courseSettings.userPermission.externalTeacher') }}</a-select-option>
              <a-select-option value="external_student">{{ $t('courseReviewDetail.courseSettings.userPermission.externalStudent') }}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <div class="submit-button">
      <a-button type="primary" @click="save">{{ $t('courseReviewDetail.courseSettings.save') }}</a-button>
    </div>
  </div>
</template>

<script>
import { getCourseSetting, courseSet, getSemesterList } from '@/api/admin'

export default {
  name: 'SetCourse',
  data() {
    return {
      form: this.$form.createForm(this),
      semesterList: []
    }
  },
  mounted() {
    getSemesterList().then(res => {
      this.semesterList = res.data.list
    })
    getCourseSetting({
      applyId: this.$route.query.id
    }).then(res => {
      if (res.code === 200) {
        this.form.setFieldsValue({
          ...res.data,
          name: res.data.courseName,
          semesterId: res.data.semesterId && res.data.semesterId !== '0' ? res.data.semesterId : undefined
        })
        this.lessonCoverUrl = res.data.lessonCover
      }
    })
  },
  methods: {
    back() {
      this.$router.push({
        name: 'courseReviewer'
      })
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.$route.query.id
          })
          courseSet(data).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('courseReviewDetail.courseSettings.saveSuccess'))
              this.back()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}

.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;

  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .down {
    width: 10px;
    margin-left: 5px;
  }
}

/deep/ .ant-input-suffix {
  right: 12px;

  img {
    width: 23px;
    cursor: pointer;
  }
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
      }
    }

    .ant-calendar-picker div {
      position: relative;

      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }

    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
}
.submit-button {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
  margin: 0 auto;
}
/deep/ .anticon {
  color: #d5d5d5 !important;
}
</style>
